import FAQ from "components/Blocks/FAQ"

const faqContent = {
  sections: [
    {
      title: null,
      faqs: [
        {
          question: "What is Preset Cloud?",
          answer:
            "Preset Cloud is a fully managed, multi-tenant cloud service built on Apache Superset. It gives your team enterprise-grade analytics with no infrastructure setup, automatic updates, and built-in security — so you can focus on building dashboards, not managing servers.",
        },
        {
          question:
            "How is Preset Cloud different from self-hosting Apache Superset?",
          answer:
            "Preset Cloud handles all infrastructure management, security patches, and version upgrades. You get enterprise features like SSO, audit logging, and row-level security without the operational overhead of running and maintaining Superset yourself.",
        },
        {
          question: "What databases can I connect to with Preset Cloud?",
          answer:
            "Preset Cloud supports 40+ data sources including Snowflake, BigQuery, Redshift, Postgres, MySQL, Databricks, and more. Any database with a SQLAlchemy connector or native Superset support is compatible.",
        },
        {
          question: "Is Preset Cloud secure and compliant?",
          answer:
            "Yes. Preset Cloud is SOC 2 Type II certified. Data is encrypted in transit and at rest. We support SSO/SAML for authentication and offer IP allowlisting on Enterprise plans.",
        },
        {
          question: "Can I embed Preset Cloud dashboards in my application?",
          answer:
            "Yes. Preset Cloud supports embedded analytics through the Embedded SDK and guest token API. You can render interactive dashboards inside your product while maintaining row-level security for multi-tenant use cases.",
        },
        {
          question:
            "What's the difference between Preset Cloud and Preset Managed Private Cloud?",
          answer:
            "Preset Cloud runs on Preset's shared infrastructure — ideal for most teams. Managed Private Cloud deploys the same platform in your own AWS, GCP, or Azure account, giving you full data residency and compliance control while Preset still handles day-to-day operations.",
        },
        {
          question: "Can I migrate my assets if I switch deployment models?",
          answer:
            "Yes. Preset exports your charts, dashboards, and datasets as standard Apache Superset YAML files. Your assets are fully portable and can be migrated to Managed Private Cloud or On-Prem at any time.",
        },
      ],
    },
  ],
}

function FAQSection() {
  return (
    <FAQ
      label="Common Questions"
      heading="Frequently Asked Questions"
      content={faqContent}
    />
  )
}

export default FAQSection
